<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="transactionTypesLoading"
    >
      <b-card>
        <b-card-title class="d-flex justify-content-between">
          <b-button
            v-if="$can('write', 'transaction-types')"
            variant="primary"
            @click="$router.push('/transaction-types/new')"
          >
            <span class="text-nowrap">Add Transaction Type</span>
          </b-button>
          <b-button
            class="btn-icon rounded-circle ml-1"
            variant="flat-primary"
            @click="fetchTransactionTypes"
          >
            <feather-icon
              icon="RefreshCwIcon"
            />
          </b-button>
        </b-card-title>
        <b-table
          ref="refTransactionTypesListTable"
          class="position-relative"
          :items="transactionTypes"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >

          <template #cell(visible_credit_list)="data">
            {{ data.item.visible_credit_list ? 'Yes' : 'No' }}
          </template>
          <template #cell(visible_debit_list)="data">
            {{ data.item.visible_debit_list ? 'Yes' : 'No' }}
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="goToEditType(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BTable, BOverlay, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import {
  onUnmounted,
} from '@vue/composition-api'
import store from '@/store'
import transactionTypesStore from '../transactionTypesStore'
import useTransactionType from '../useTransactionType'

export default {
  components: {
    BCard,
    BCardTitle,
    BTable,
    BOverlay,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  setup(_, ctx) {
    const TRANSACTION_TYPES_STORE_MODULE_NAME = 'transactionTypes'
    if (!store.hasModule(TRANSACTION_TYPES_STORE_MODULE_NAME)) store.registerModule(TRANSACTION_TYPES_STORE_MODULE_NAME, transactionTypesStore)

    onUnmounted(() => {
      if (store.hasModule(TRANSACTION_TYPES_STORE_MODULE_NAME)) store.unregisterModule(TRANSACTION_TYPES_STORE_MODULE_NAME)
    })
    const {
      tableColumns,
      transactionTypes,
      transactionTypesLoading,
      fetchTransactionTypes,
      goToEditType,
    } = useTransactionType(ctx)

    return {
      tableColumns,
      transactionTypes,
      transactionTypesLoading,
      fetchTransactionTypes,
      goToEditType,
    }
  },
}
</script>

<style>

</style>
